import Vue from 'vue'
import Router from 'vue-router'

import Paths from './constants/paths';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
  ]
})
